import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./FavouritesButton.module.scss";
import {
  AnalyticsTypeMap,
  ODDS_VIEW,
  UPDATE_FAVOURITES_VIEW,
} from "../../../../constants";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";
import { ADD, FAVOURITES } from "../../../../constants/analytics";

export const FavouritesButton = ({
  disabled,
  storeNewFavourite,
  hasStoredFavourites,
}) => {
  const dispatch = useDispatch();
  const { responseMessage, prefetchedFilters } = useSelector(
    (state) => state.filter
  );
  const { loggedIn, activeFilterView } = useSelector((state) => state.view);

  useEffect(() => {
    let timer;
    if (responseMessage?.message) {
      timer = setTimeout(
        () => dispatch({ type: "UpdateFavouritesResponse", payload: null }),
        4000
      );
    }

    return () => clearTimeout(timer);
  }, [responseMessage]);

  const handleClick = () => {
    // handle navigation to favourites view if the user has already added the selections to their favourites
    if (hasStoredFavourites) {
      sendAnalyticsEvent({
        event: FAVOURITES,
        type:
          activeFilterView === ODDS_VIEW
            ? AnalyticsTypeMap.get(activeFilterView)
            : activeFilterView,
        action: ADD,
      });
      dispatch({ type: "SET_ACTIVE_VIEW", payload: UPDATE_FAVOURITES_VIEW });
    } else {
      if (!loggedIn) {
        const filterSelections = prefetchedFilters[activeFilterView];
        // store the current view and presetFilter
        localStorage.setItem(
          "login",
          JSON.stringify({
            view: activeFilterView,
            filterSelections,
          })
        );
      }
      storeNewFavourite();
    }
  };

  const messageReceived = responseMessage !== null;

  let messageClass = "";
  if (messageReceived) {
    messageClass = responseMessage?.code === 0 ? "success-text" : "error-text";
  }

  if (!loggedIn) {
    return null;
  }
  return (
    <button
      disabled={disabled}
      className={styles["favourites-button"]}
      onClick={handleClick}
    >
      <span
        aria-hidden={messageReceived}
        className={`${styles["text"]} ${styles["default-text"]} ${
          messageReceived ? styles["hide"] : styles["show"]
        }`}
      >
        Add to Favourites
      </span>
      <span
        aria-hidden={!messageReceived}
        className={`${styles["text"]} ${styles[messageClass]} ${
          messageReceived ? styles["show"] : styles["hide"]
        }`}
      >
        {responseMessage?.message ?? ""}
      </span>
    </button>
  );
};
